import { Component, OnInit } from '@angular/core';
import { AccountService } from '../_services/account.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from "@angular/forms";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountImport } from '../_models/index';

@Component({
  selector: 'accountimport',
  templateUrl: './accountoperationbankimport.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})
export class AccountOperationbankImport implements OnInit {

  customerPuplic_key: any;
  user_public_id: any;
  data: any;
  excelHeader: any;
  uploadedFileName: any;
  enableImportExcel: boolean;
  enableImportConfirm: boolean;
  formData: FormData = new FormData();
  searchFilterForm: FormGroup;
  enableEdit: boolean = true;
  tab1ActiveStatus: any;
  tab2ActiveStatus: any;
  tab3ActiveStatus: any;
  tab1Visibility: any;
  tab2Visibility: any;
  tab3Visibility: any;
  excelProcessStatus: any;
  ProcessTitle: any;
  ProcessSubTitle: any;
  processErrorDetails: any;
  customer_Account_public_id: any;
  subscriptionId: any;

  public tFileList: File;
  constructor
    (
      private router: Router
      , private spinnerService: Ng4LoadingSpinnerService
      , private accountService: AccountService
      , private activatedRoute: ActivatedRoute
      , private formBuilder: FormBuilder
    ) {


  }//end const

  ngOnInit() {


    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customerPuplic_key = localStorage.getItem('companyId');
        this.user_public_id = localStorage.getItem('userId');
      }
    }
    else {
      this.customerPuplic_key = localStorage.getItem('subcompanyId');
      this.user_public_id = localStorage.getItem('userId');
    }
    //used to retrieve the customer Account public id
    let params: any = this.activatedRoute.snapshot.params;
    this.customer_Account_public_id = params.id;
    this.enableImportExcel = false;
    this.enableImportConfirm = false;

    this.searchFilterForm = this.formBuilder.group({
      edt: ['']
    });

    this.GetAccountsDetails();
    this.tab1ActiveStatus = "active";
    this.tab2ActiveStatus = "disabled";
    this.tab3ActiveStatus = "disabled";
    this.tab1Visibility = true;
    this.tab2Visibility = false;
    this.tab3Visibility = false;
    this.uploadedFileName = "Archivo a subir";
  }


  /** This function is used to get the account account details from the service; 
   * it accepts the param account public id
   */
  GetAccountsDetails() {

    this.accountService.getAccount(this.customer_Account_public_id).subscribe(data => {
      if (data.configuration.subscription_id != 'undefined') {
        this.subscriptionId = data.configuration.subscription_id;
      }


    },
      error => {
        console.log('Failed! while trying to get the acccount details list. ' + error);
      });
  }//end

  onFileChange(event: any) {

    this.spinnerService.show();
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    if (target.files.length !== 1 && event.target.accept !== ".xls") throw new Error('Cannot use multiple files');
    this.uploadedFileName = target.files[0].name;
    if (target.files.length == 1 && (target.files[0].type == ".xls" || target.files[0].type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || target.files[0].type == "application/vnd.ms-excel")) {
      this.enableImportExcel = true;
      this.uploadedFileName = event.target.files[0].name;

      if (event.target.files.length > 0) {
        const file = event.target.files[0];
        this.tFileList = event.target.files[0];
        this.searchFilterForm.get('edt').setValue(file);
      }


      // }
    }
    else {
      this.enableImportExcel = false;
      this.processErrorDetails = "Please select .xls or .xlsx file only!";
    }
    this.spinnerService.hide();
    //       }//end onfilechange
  }

  btngoBack() {
    this.router.navigate([`/accounts/bank/${this.customer_Account_public_id}/operations`]);
  }

  importExcelData(event, { value }: { value: AccountImport }) {

    this.formData.append('edt', this.searchFilterForm.get('edt').value);


    this.formData.append('subscription_public_id', this.subscriptionId);

    this.accountService.AccountImport(this.formData).subscribe(val => {

      if (val.status == '202') {
        this.tab1ActiveStatus = "disabled";
        this.tab2ActiveStatus = "active";
        this.tab3ActiveStatus = "disabled";
        this.tab1Visibility = false;
        this.tab2Visibility = true;
        this.tab3Visibility = false;
        this.ProcessTitle = "Archivo ha sido recibido correctamente ..";
        this.ProcessSubTitle = "Click [Confirmar] para comenzar el proceso de importación.";
      }
    },
      err => {
        console.log("POST call in error", err.status);
      });
  }

  importConfirm() {
    this.enableEdit = false;

    setTimeout(() => {
      this.accountService.accountImportStep1().subscribe(val => {


        this.ProcessTitle = "Archivo esta siendo procesado ..";
        this.ProcessSubTitle = "Procesando registros …";

        this.importConfirmStep2();

      },
        err => {
          this.enableEdit = true;
          console.log("POST call in error", err.status);
        })
    }, 2);
  }


  importConfirmStep2() {

    setTimeout(() => {
      this.accountService.accountImportStep2().subscribe(val => {


        this.ProcessTitle = "Archivo esta siendo procesado ..";
        this.ProcessSubTitle = "Sincronizando registros …";
        this.importConfirmStep3();
      },
        err => {
          console.log("POST call in error", err.status);
        });
    }, 2);
  }

  importConfirmStep3() {
    setTimeout(() => {
      this.accountService.accountImportStep3().subscribe(val => {

        this.tab1ActiveStatus = "disabled";
        this.tab2ActiveStatus = "disabled";
        this.tab3ActiveStatus = "active";
        this.tab1Visibility = false;
        this.tab2Visibility = false;
        this.tab3Visibility = true;

        this.excelProcessStatus = 'Archivo ha sido procesado !!!';
        // }
      },
        err => {
          console.log("POST call in error", err.status);
        });
    }, 2);
  }
}